import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import {Link as ChakraLink} from "@chakra-ui/react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PathsE, PathsParams } from "shared/routes";
import useGetColors from "shared/hooks/useGetColors";
import { NewsDTO } from "shared/api/types/news";
import { Divider, Flex, IconButton, Text } from "@chakra-ui/react";
import CutText from "shared/components/CutText";
import MuiIcon from "../../../../components/MuiIcon";
import Link from "../../../components/Link";

export const useGetGetBreadcrumbs = () => {
  const { t } = useTranslation();
  return [
    {
      path: PathsE.HOME,
      text: t("general.home"),
    },
  ];
};

interface Params {
  handleDelete: (id: number) => void;
  isDeletePending: boolean;
  serviceId: string,
}

export const useGetColumns = ({
  handleDelete,
  isDeletePending,
  serviceId,
}: Params) => {
  const { t } = useTranslation();
  const { red500, blue500 } = useGetColors();

  const columnHelper = createColumnHelper<NewsDTO>();

  const handleDeleteRow = async (id: number) => {
    await handleDelete(id);

  };

  return useMemo(
    () =>
      [
        columnHelper.accessor("id", {
          cell: ({ getValue }) => <Text fontWeight={700}>{getValue()}</Text>,
          header: "Id",
          id: "id",
          meta: {
            isSorting: false,
            styles: { sizes: { maxW: "40px", width: "40px" } },
          },
        }),
        columnHelper.accessor("text", {
          cell: ({ getValue }) => <CutText enableTooltip>{getValue()}</CutText>,
          header: "Text",
          id: "text",
          meta: { styles: { sizes: { maxW: "450px", width: "450px" } } },
        }),
        columnHelper.accessor("url", {
          cell: ({ getValue }) => {
            return (
              <Flex alignItems="center" gap={4}>
                <Divider
                  orientation="vertical"
                  borderColor="blackAlpha.500"
                  height="24px"
                  w="1px"
                />
                <CutText color={blue500} enableTooltip fontWeight="700">
                  <ChakraLink href={getValue()} target="_blank">
                    {getValue()}
                  </ChakraLink>
                </CutText>
                <Divider
                  orientation="vertical"
                  borderColor="blackAlpha.500"
                  height="24px"
                  w="1px"
                />
              </Flex>
            );
          },
          header: "URL",
          id: "url",
          meta: { styles: { sizes: { maxW: "600px" } } },
        }),
        columnHelper.accessor("status", {
          cell: ({ getValue }) => <Text>{getValue()}</Text>,
          header: "Status",
          id: "status",
          meta: { styles: { sizes: { maxW: "80px", width: "80px" } } },
        }),
        // columnHelper.accessor("datetimeOfCreate", {
        //   header: "Create Time",
        //   id: "datetimeOfCreate",
        //   meta: { styles: { sizes: { maxW: "150px", width: "150px" } } },
        //   cell: ({ getValue }) => {
        //     const value = getValue();
        //     if (!value) return null;
        //     return <span>{formatDateToHuman(getValue())}</span>;
        //   },
        // }),
        // columnHelper.accessor("sendTime", {
        //   header: "Send Time",
        //   id: "sendTime",
        //   meta: { styles: { sizes: { maxW: "150px", width: "150px" } } },
        //
        //   cell: ({ getValue }) => {
        //     const value = getValue();
        //     if (!value) return null;
        //     return <span>{formatDateToHuman(getValue())}</span>;
        //   },
        // }),
        // columnHelper.accessor("editTime", {
        //   header: "End Time",
        //   id: "editTime",
        //   meta: { styles: { sizes: { maxW: "150px", width: "150px" } } },
        //   cell: ({ getValue }) => {
        //     const value = getValue();
        //     if (!value) return null;
        //     return <span>{formatDateToHuman(getValue())}</span>;
        //   },
        // }),

        columnHelper.accessor("id", {
          header: "",
          id: "actions",
          cell: ({ row }) => {
            const id = row.original.id;
            return (
              <Flex>
                <Link<PathsParams[PathsE.UPDATE_NEWS]> path={PathsE.UPDATE_NEWS} pathsParams={{ serviceId, id: String(id) }}>
                  <IconButton
                    mr="2"
                    aria-label="Edit"
                    borderRadius="10px"
                    backgroundColor="transparent"
                    icon={<MuiIcon name="edit" color={blue500} />}
                  />
                </Link>

                <IconButton
                  aria-label="Delete"
                  onClick={() => handleDeleteRow(id)}
                  borderRadius="10px"
                  backgroundColor="transparent"
                  icon={<MuiIcon name="delete" color={red500} />}
                />
              </Flex>
            );
          },
        }),
      ] as ColumnDef<NewsDTO>[],
    [t, isDeletePending],
  );
};
